import React from 'react'
import {
    Container,
    makeStyles,
    Card,
} from "@material-ui/core";
const loginStyles = makeStyles((theme) => ({
    page: {
        background: "#717775",
    },
    loginContainer: {
        display: "flex",
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
    },
    root: {
        display: "flex",
        flexGrow: 1,
    },
    cardMedia: {
        display: "flex",
        width: "1000px",
    },


}));
const NotFound = () => {
    const classes = loginStyles();

    return (
        <div className={classes.page}>
            <Container
                component='main'
                maxWidth='md'
                className={classes.loginContainer}
            >
                <Card
                    style={{
                        width: "960px", height: "640px",
                    }}
                    className={classes.root}
                >
                    <div
                        style={{
                            backgroundImage: `url(/Img/NotFound.svg)`,
                            backgroundRepeat: "no-repeat",
                            marginTop: '40px'
                        }}
                        className={classes.cardMedia}
                    >

                    </div>
                </Card>
            </Container>
        </div>
    )
}

export default NotFound
